export default {
  first: [
    "Автоматизация планирования",
    "Разработка инструментальной среды",
    "Организационные аспекты",
    "Формирование системы",
    "Управление учебно-тренировочным процессом",
    "Педагогическая технология",
    "Психолого-педагогическое сопровождение",
    "Повышение эффективности",
    "Механизм управления",
    "Трансформация политической системы",
    "Инвестиционное обеспечение",
    "Инновационно-инвестиционные механизмы",
    "Управление инвестиционной активностью",
    "Формирование механизма реализации",
    "Особенности развития",
    "Психологические особенности смысловой саморегуляции",
    "Дидактические основы",
    "Имплицитные теории личности",
    "Семантическое поле",
    "Государственное регулирование",
    "Обеспечение безопасности",
    "Нормативно-правовое регулирование экономической системы в условиях",
    "Моделирование",
    "Полицеистика и идея государственности",
    "Влияние скандинаво-германских и византийских правовых традиций",
    "Политико-правовые основы становления и развития системы публичного управления",
    "Финансовое управление и денежное обращение",
    "Зарождение и развитие государственного регулирования",
    "Регулирование развития",
    "Историко-патриотическое воспитание",
    "Организационные основы",
    "Криминологическая характеристика",
    "Организационно-экономическое обеспечение",
    "Клиническая, медико-правовая оценка"
  ].map((t, id) => ({ id, t })),
  second: [
    "истероидной акцентуации личности",
    "деятельности религиозных объединений в Российской Федерации",
    "в системе государственного регулирования экономико-правовых отношений",
    "трансформации современного российского общества и государства",
    "в современной российской государственности",
    "в истории правовых учений",
    "политических партий и движений",
    "адвокатской деятельности и адвокатуры",
    "банковской системы",
    "семейных отношений",
    "Русской православной церкви",
    "средствами самодеятельного туризма",
    "противодействия в ходе судебного следствия по уголовным делам",
    "как фактор устойчивого развития экономики региона",
    "современного геометро-графического образования",
    "дефектов оказания дерматовенерологической помощи",
    "и управление ресурсами",
    "для сети ремонтных предприятий",
    "интеграции программных приложений",
    "формирования и развития",
    "управления персоналом",
    "по овладению техникой катания на коньках",
    "профессиональной подготовки руководителей нештатных аварийно-спасательных формирований",
    "профессионального становления",
    "блочно-модульного обучения в развитии интеллектуальных качеств",
    "инвестиционными процессами",
    "общества в эпоху глобализации",
    "научно-технических проектов",
    "развития",
    "населения",
    "инновационных программ",
    "смысловой дивергенции слушателей",
    "банковских служащих среднего звена",
    "развития ответственности"
  ].map((t, id) => ({ id, t })),
  third: [
    "при формировании производственной программы промышленного объединения",
    "в условиях вероятностной неопределенности",
    "для организации обучения персонала предприятий",
    "малых и средних промышленных предприятий",
    "на предприятиях машиностроения",
    "(на примере СДЮШОР по хоккею СКА Санкт-Петербург)",
    "с использованием обучающих игр",
    "сотрудников ГПС МЧС России",
    "специалиста в вузе",
    "на рынке недвижимости",
    "на муниципальном уровне",
    "предприятия",
    "культурно-развлекательного комплекса",
    "в современной экономике",
    "в условиях наукограда",
    "в период получения дополнительной квалификации",
    "в период экономического кризиса",
    "у старшеклассников",
    "(на материале английского и русского языков)",
    "(вопросы теории и практики)",
    "как фактор семантико-прагматической организации диалогического дискурса",
    "(теоретико-правовые проблемы)",
    "(политико-правовое исследование)",
    "(теоретико-правовое исследование)",
    "в Российской Федерации",
    "(историко-правовой аспект)",
    "в централизованном Московском государстве с XIV по XVII",
    "сравнительно-правовой анализ исторического развития и формирования нормативно-правовой базы",
    "в Древней Руси",
    "в Древнерусском государстве IX-XIII вв.",
    "в эволюции российского права с IX по XX века",
    "в суде первой инстанции",
    "(на материалах Кабардино-Балкарской Республики)",
    "(как историко-педагогическая проблема)"
  ].map((t, id) => ({ id, t }))
};
